import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  MenuItem
} from "@mui/material";
import { useState } from "react";
import { stockService } from "../service/CreateStockService";

const TransferDialog = ({ open, onClose, bike, onSuccess }) => {

  const [form, setForm] = useState({
    toLocation: "",
    otherLocationName: "",
    challanNo: "",
    date: new Date().toISOString().split("T")[0],
    amount: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!form.toLocation) {
      alert("Select location");
      return;
    }

    if (form.toLocation === "Other" && !form.otherLocationName.trim()) {
      alert("Please enter the other location name");
      return;
    }

    try {
      await stockService.transferStock({
        bikeId: bike._id,
        toLocation: form.toLocation,
        otherLocationName: form.toLocation === "Other" ? form.otherLocationName : undefined,
        challanNo: form.challanNo,
        amount: form.amount,
        date: form.date,
      });

      onSuccess();
      onClose();

    } catch (err) {
      alert(err.response?.data?.message || "Transfer failed");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Transfer Bike</DialogTitle>

      <DialogContent>
        <Grid container spacing={2} mt={1}>

          {/* DATE */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Date"
              type="date"
              name="date"
              value={form.date}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* LOCATION */}
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="To Location"
              name="toLocation"
              value={form.toLocation}
              onChange={handleChange}
            >
              <MenuItem value="Khejuri">Khejuri</MenuItem>
              <MenuItem value="Chaitanyapur">Chaitanyapur</MenuItem>
              <MenuItem value="Nandigram">Nandigram</MenuItem>
              <MenuItem value="Ms Enterprise">Ms Enterprise</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </TextField>
          </Grid>

          {/* OTHER LOCATION NAME */}
          {form.toLocation === "Other" && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Other Location Name"
                name="otherLocationName"
                value={form.otherLocationName}
                onChange={handleChange}
              />
            </Grid>
          )}

          {/* CHALLAN */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Challan No"
              name="challanNo"
              value={form.challanNo}
              onChange={handleChange}
            />
          </Grid>

          {/* AMOUNT */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Amount"
              name="amount"
              value={form.amount}
              onChange={handleChange}
            />
          </Grid>

        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Transfer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransferDialog;